export default function KpiCard({ label, value, delta, tone = "up", testId, mono = true }) {
  const deltaColor =
    tone === "up" ? "text-[#0e8a68]" : tone === "down" ? "text-[#ef5757]" : "text-[#5c6877]";
  return (
    <div
      className="bg-white border border-[#e7e9ee] rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow"
      data-testid={testId}
    >
      <div className="text-[11px] uppercase tracking-[.09em] text-[#5c6877] font-semibold mb-2">{label}</div>
      <div className={`${mono ? "font-mono-data" : "font-display"} text-[26px] font-bold text-[#0e1420] leading-none`}>
        {value}
      </div>
      {delta && <div className={`text-[11.5px] mt-2 ${deltaColor} flex items-center gap-1`}>{delta}</div>}
    </div>
  );
}
